import { Controller } from "stimulus"

// Clicks catalog-refresh has not yet reflected. It refreshes only after one of these,
// so returning to the tab without opening anything costs no request.
export const clicksSinceRefresh = new Set()

export default class extends Controller {
  track(e){
    const id = e.currentTarget.dataset.interactableId
    const type = e.currentTarget.dataset.interactableType
    const csrf = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    const request = fetch('/click_interactions', {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrf
      },
      body: JSON.stringify({ id, type }),
      // Saverlife-hosted resources navigate the current document on this same click,
      // which would cancel a plain fetch before the click is recorded.
      keepalive: true
    }).then((response) => {
      // A resource's completion — and its permanent removal from Your next steps —
      // derives from the row this POST creates, so a silent failure is a product
      // regression rather than a lost analytics event. An expired session answers
      // 200 with a sign-in page, so success is the controller's 201, not response.ok.
      if (response.status === 201) return

      globalThis.Rollbar?.error("ClickTracker: click not recorded", {
        status: response.status, interactable_type: type, interactable_id: id
      })
    }).catch((err) => {
      globalThis.Rollbar?.error(err, {
        detail: "ClickTracker: failed to record click",
        interactable_type: type, interactable_id: id
      })
    })
    clicksSinceRefresh.add(request)
  }
}
